export enum DeviceType {
	DESKTOP = 'desktop',
	MOBILE = 'mobile',
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/device/DeviceType.ts